const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const {processTemplateData, getEventType} = require('../../utils');

module.exports = withRenderedMain(BaseView.extend({
    selectors: {
        benefitsContainer: '.benefits_container',
        savingsContainer: '.savings_container',
        stepsContainer: '.steps_container',
        primeStartTrial: '.prime_start_trial',
        backgroundImage: '.background_image',
    },
    events: {
        'tap .prime_start_trial': 'onPrimeStartTrialClick',
    },
    initialize: function() {
        this.listenTo(this.model, 'change:offerPrice', this.render);
        if (this.model.get('offerPrice')) {
            this.render();
        }
    },
    renderBackgroundImage() {
        return this.model.isPrimeFreeForAll()
            ? this.$el.find(this.selectors.backgroundImage).addClass('od-header-image-background-free-for-all')
            : this.$el.find(this.selectors.backgroundImage).addClass('od-header-image-background-guy-jumping');
    },
    render() {
        this.renderBackgroundImage();
        if (this.model.isMobile()) {
            const trackingPageLabel = this.model.get('openRegisterForm') ?
                getEventType(this.model.isRegistered(), true) : 'start';
            this.model.trackPage(trackingPageLabel);
        }
        const formattedPrice = Odigeo.Utils.formatCurrency(this.model.get('offerPrice'));
        this.keys.primeBenefitsSubtitle.perkFour = Odigeo.Utils.replaceCmsKeyArgs(this.keys.primeBenefitsSubtitle.perkFour, formattedPrice);
        this.$el.find(this.selectors.benefitsContainer).append(this.templates.benefits({keys: this.keys}));
        this.$el.find(this.selectors.savingsContainer).append(this.templates.savings({
            keys: this.keys,
            showMoreMembershipPriceRange: Odigeo.Membership.showMoreMembershipPriceRange,
        }));
        this.$el.find(this.selectors.stepsContainer).append(this.templates.steps({keys: this.keys}));
    },
    onPrimeStartTrialClick() {
        const action = this.model.isMobile() ? 'openRegisterForm' : 'submitForm';
        this.model.set(action, true);
        this.model.set('eventType', 'start');
        this.model.trackEvent('register', this.model.isRegistered());
        this.setNextCategoryEv();
    },
    setNextCategoryEv() {
        this.model.set('eventType', getEventType(this.model.isRegistered()));
    },
}), processTemplateData);
